import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Tooltip from "@mui/material/Tooltip";
// @mui/icons-material
import Reply from "@mui/icons-material/Reply";
import Favorite from "@mui/icons-material/Favorite";
// core components
import GridContainer from "/components/Grid/GridContainer.js";
import GridItem from "/components/Grid/GridItem.js";
import Media from "/components/Media/Media.js";
import Button from "/components/CustomButtons/Button.js";
import CustomInput from "/components/CustomInput/CustomInput.js";

import sectionCommentsStyle from "/styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionCommentsStyle.js";

const useStyles = makeStyles(sectionCommentsStyle);

// Append commento
const appendScript = (src, scriptId, parentId) => {
  const parentNode = window.document.getElementById(parentId);
  if(parentNode) {
    const script = window.document.createElement('script');
    script.id = scriptId;
    script.src = src;
    script.async = true;
    script.defer =  true;
    parentNode.appendChild(script);
  }
}

// Remove commento
const removeScript = (scriptId, parentId) => {
  const parentNode = window.document.getElementById(parentId);
  if(parentNode) {
    const scriptNode = window.document.getElementById(scriptId);
    parentNode.removeChild(scriptNode);
  }
}

/**
 * Component
 * @returns 
 */
export default function SectionComments() {
  const classes = useStyles();

  // Commento
  React.useEffect(() => {
    const scriptId = 'commento-script';
    const scriptParentId = 'script-parent';
    const scriptSrc = 'https://cdn.commento.io/js/commento.js';

    if(!window) return;
    appendScript(scriptSrc, scriptId, scriptParentId);

    return(() => {
      if(!window) return;
      removeScript(scriptId, scriptParentId);
    })
  });

  return (
    <div className={classes.section} id='script-parent'>
      <div id="commento" />
    </div>
  );
}
